var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.format == 'markdown')?_c(_setup.ToolHelpMarkdown,{attrs:{"content":_vm.content}}):(_vm.format == 'restructuredtext')?_c(_setup.ToolHelpRst,{attrs:{"content":_vm.content}}):_c('div',{staticClass:"form-help form-text"},[_vm._v("\n        "+_vm._s(_vm.content)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }